module.exports = __webpack_public_path__ + "static/media/background.b0c62bb9.png";